import {
  generateCustomShortFormVideoIdeas,
  deleteLastDraftCustomShortVideo,
  getLastDraftCustomShortVideo,
  getVideos,
  saveCustomShortVideo,
} from "./videos.service";

export const videosService = {
  getVideos,
  generateCustomShortFormVideoIdeas,
  saveCustomShortVideo,
  getLastDraftCustomShortVideo,
  deleteLastDraftCustomShortVideo,
};
